import styles from './Page404.module.css'

export default function Page404(){
    return(
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>404</h1>
                <h4>Ops!! Página não encontrada</h4>
                <p>
                    A página que você está procurando não existe. Você deve ter
                    digitado errado o endereço ou a página pode ter sido movida
                    para outro local.
                </p>
            </div>
        </div>
    )
}